// 공개 금액은 구간으로만 — 1억 미만은 천만 단위(「3천만 원대」), 1억 이상은 억 단위, 10억 이상은 한 칸으로 묶는다.

const TEN_MILLION = 10_000_000;
const HUNDRED_MILLION = 100_000_000;
const BILLION = 1_000_000_000;

export const amountBandOf = (won: number | null | undefined): string | null => {
  if (typeof won !== "number" || !Number.isFinite(won) || won <= 0) return null;
  if (won < TEN_MILLION) return "1천만 원 미만";
  if (won < HUNDRED_MILLION) return `${Math.floor(won / TEN_MILLION)}천만 원대`;
  if (won < BILLION) return `${Math.floor(won / HUNDRED_MILLION)}억 원대`;
  return "10억 원 이상";
};
